export const ERROR = {
  'no fill out of email field': 'メールアドレスを入力してください。',
  'no fill out of password field': 'ログインメールアドレスまたはパスワードが一致しません。',
  'valid email address': '有効なメールアドレスを入力してください。',
  'password is not match': 'ログインメールアドレスまたはパスワードが一致しません。',
};
